import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import Benchmarks from '../containers/DirectorDashboard/Benchmarks';
import StatisticReport from '../containers/DirectorDashboard/StatisticReport';
import ProjectReport from '../containers/DirectorDashboard/ProjectReport';
import ModuleSettings from '../containers/DirectorDashboard/ModuleSettings';

export default function DirectorDashboardRouting() {
  return (
    <Switch>
      <Route component={Benchmarks} path="/director-dashboard/benchmarks" />
      <Route component={StatisticReport} path="/director-dashboard/statistic-report" />
      <Route component={ProjectReport} path="/director-dashboard/project-report" />
      <Route component={ModuleSettings} path="/director-dashboard/module-settings/:id" />
      {/* <Route component={ModuleSettings} path="/director-dashboard/module-settings" /> */}
      <Redirect from="/director-dashboard" to="/director-dashboard/statistic-report" />
    </Switch>
  );
}
